import React, { useState, useEffect, useContext } from "react";
import ReactDOM from "react-dom"; // Importe o ReactDOM aqui
import { QRCodeCanvas } from "qrcode.react";
import LoadingCircle from "../../Loading/LoadingCircle";
import { gerarPixDisparos, verificarPagamentoShotSale } from "../../../Services/dbservice";
import { AuthContext } from "../../../Context/AuthContext";
import { LoadingContext } from "../../../Context/LoadingContext";
import func from "../../../Services/fotmatters";
import style from "./PayMoreDisparosStyle";

export default function PayMoreDisparos({ onClose, onSuccess, totalValue, quantidade }) {
  const [pixInfo, setPixInfo] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const { credentials } = useContext(AuthContext);
  const { startLoading, stopLoading } = useContext(LoadingContext);

  useEffect(() => {
    generatePix();
  }, []);

  const generatePix = async () => {
    try {
      const response = await gerarPixDisparos(
        credentials.accessToken,
        totalValue,
        quantidade
      );
      setPixInfo(response);
    } catch (error) {
      alert("Erro ao gerar PIX para a compra de disparos.");
      onClose();
    }
  };

  const verificarPix = async () => {
    if (!pixInfo || !pixInfo.id) return;
    try {
      startLoading();
      const response = await verificarPagamentoShotSale(
        credentials.accessToken,
        pixInfo.id
      );
      handleVerifyPaymentMessage(response.data.status);
    } catch (error) {
      alert("Erro ao verificar o pagamento PIX.");
      console.log(error);
    } finally {
      stopLoading();
    }
  };

  const handleVerifyPaymentMessage = (status) => {
    if (status === "pending") {
      alert("Pagamento ainda não foi aprovado.");
    } else if (status === "approved" || status === "paid") {
      alert(
        "Pagamento verificado com sucesso!\nSeus disparos serão creditados em breve."
      );
      onSuccess();
    } else {
      alert("Status indefinido, entre em contato com o suporte.");
    }
  };

  useEffect(() => {
    if (pixInfo) {
      setQrCode(pixInfo.point_of_interaction.transaction_data.qr_code);
    }
  }, [pixInfo]);

  // A mágica do Portal acontece aqui!
  return ReactDOM.createPortal(
    <div style={style.container}>
      <div style={style.containerBox}>
        <span style={style.title}>Pague com PIX para liberar seus disparos</span>
        <div style={style.qrCodeContainer}>
          {!qrCode && <LoadingCircle loading={true} />}
          {qrCode && (
            <QRCodeCanvas
              value={qrCode}
              size={280}
              level="H"
              includeMargin={true}
              style={style.qrCode}
            />
          )}
        </div>
        <div style={style.valueAndButtons}>
          <div style={style.valueAndButtonsCenter}>
            <span style={style.valueTitle}>VALOR A PAGAR</span>
            <span style={style.valueValue}>
              {func.formatarMoeda(totalValue)}
            </span>
          </div>
          <button onClick={verificarPix} style={style.verifyPaymentButton}>
            Já paguei, verificar
          </button>
          <button onClick={onClose} style={style.exitButton}>
            Cancelar
          </button>
        </div>
      </div>
    </div>,
    document.body // O segundo argumento diz para renderizar no corpo do documento
  );
}